import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import AuthenStore from 'stores/AuthenStore'
import { Row, Col } from 'react-bootstrap'
import './Org.css'

class OrganizationSelectionPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data:[]
    }
  }

  componentDidMount() {
    this.loadData()
  }

  componentWillReceiveProps(newProps){

  }

  loadData() {
    this.setState({loading:true})
    AuthenStore.loadOrgList((result)=>{
        this.setState({loading:false,data:result.orglist})
    },(failed)=>{
        this.setState({loading:false})
    })
  }

  async onOrgClick(item){
    let result = await AuthenStore.changeOrg(item.bf_org_id)

    // console.log('result',item,result)
    if(result.status==='OK'){
        if (process.env.NODE_ENV == "development") {
            //window.redirect('https://' + window.location.host + window.location.pathname );
            window.location.reload(true);
        }else{
            window.location.reload(true)
        }
    }
  }

  renderOrg() {
      let {data} = this.state
      
      if (data.length==0) {
          return(
            <Row>
                <Col md={5}>
                    <div className="box box-widget widget-user box-org" style={{pointerEvents:'none'}}>
                        <div className="widget-user-header bg-black" style={{backgroundSize:'500px 180px',background:'url("https://demo2.bigfix.co/korat/img/logo-demo2-500x274.png") center'}}>
                            <h3 className="widget-user-username" style={{fontWeight:'bold',color:'white'}}><br/></h3>
                            <h5 className="widget-user-desc" style={{display:'none'}}><br/></h5>
                            <div className="widget-user-org-id" style={{display:'none'}}><br/></div>
                        </div>
                        <div className="widget-user-image">
                            <img className="img-circle" src="//static.bigfix.co/img/bigfix-logo-128.png" alt="User Avatar"></img>
                        </div>
                        <div className="box-footer">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="description-block">
                                        <h5 className="description-header job-done"><br/></h5>
                                        <span className="description-text">ไม่พบข้อมูลบริษัท</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={7}></Col>
            </Row> 
          )
      } else {
        return(
            data.map((item,index)=>{  
                return(
                    <Row>
                        <Col md={5}>
                        <div onClick={this.onOrgClick.bind(this,item)} className="box box-widget widget-user box-org" style={{cursor:'pointer'}}>
                            <div className="widget-user-header bg-black" style={{backgroundSize:'500px 180px',background:'url("https://demo2.bigfix.co/korat/img/logo-demo2-500x274.png") center'}}>
                                <h3 className="widget-user-username" style={{fontWeight:'bold',color:'white'}}>{item.bf_org_name}</h3>
                                <h5 className="widget-user-desc" style={{display:'none'}}>สิทธิ์ใช้งานทั่วไป</h5>
                                <div className="widget-user-org-id" style={{display:'none'}}>korat</div>
                            </div>
                            <div className="widget-user-image">
                                <img className="img-circle" src="//static.bigfix.co/img/bigfix-logo-128.png" alt="User Avatar"></img>
                            </div>
                            <div className="box-footer">
                                <div className="row">
                                    <div className="col-sm-4 border-right">
                                        <div className="description-block">
                                            <h5 className="description-header cash-count">{item.stat.cash}</h5>
                                            <span className="description-text">แจ้งซ่อมเงินสด (คัน)</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 border-right">
                                        <div className="description-block">
                                            <h5 className="description-header insurer-count">{item.stat.insurer}</h5>
                                            <span className="description-text">แจ้งซ่อมประกัน (คัน)</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="description-block">
                                            <h5 className="description-header job-done">{item.stat.job_done}</h5>
                                            <span className="description-text">ปิดงาน(คัน)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Col>
                        <Col md={7}></Col>
                    </Row>    
                )
            })
        )        
    }    
  }

  render() {
    return(
        <div className='org-select-page'>
            <div className='wrapper'>
                <Box load={this.state.loading} className='bt-n'>
                    <div className='content org-content'>
                        <h2 className='page-header'>เลือกบริษัท</h2>
                        {this.renderOrg()}
                    </div>    
                </Box>    
            </div>
        </div>        
    )
  }
}

OrganizationSelectionPage.defaultProps = {

}
export default OrganizationSelectionPage;


// WEBPACK FOOTER //
// ./src/view/org/OrganizationSelectionPage.js